export default "__VITE_ASSET__BmXeoq14__"